import { UseExploreItemsParams } from '../api/explore'

export const all = ['tripExplore'] as const
export const items = (params: UseExploreItemsParams) =>
  [...all, 'items', params] as const
